import "./App.css";
import NavigationBar from "./components/NavigationBar";
import { Route, Routes } from "react-router-dom";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import RecipesPage from "./pages/RecipesPage";
import RecipeDetailPage from "./pages/RecipeDetailPage";
import AboutUs from "./pages/AboutUs";
import BlogPage from "./pages/BlogPage";
import BlogDetail from "./components/BlogDetails";
import Products from "./pages/Products";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminLogin from "./components/AdminLogin";
import ProtectedRoute from "./components/ProtectedRoute";
import AllProductsPage from "./pages/AllProductsPage";
import VideosSection from "./components/VideosSection";
import AllVideosSection from "./components/AllVideosSection";
import ProductDescription from "./components/ProductDescription";

function App() {
  return (
    <>
      <div>
        <NavigationBar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/recipes" element={<RecipesPage />} />
          <Route path="/recipeList" element={<RecipesPage />} />
          <Route path="/recipe/:id" element={<RecipeDetailPage />} />
          <Route path="/product/:id" element={<ProductDescription />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/products" element={<Products />} />
          <Route path="/all-products" element={<AllProductsPage />} />
          <Route path="/videos" element={<VideosSection />} />
          <Route path="/all-videos" element={<AllVideosSection />} />
          <Route path="/aboutUs" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
      <Footer />
    </>
  );
}

export default App;
